var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "guarantee", title: "Guarantee" } },
    [
      _vm._v("\n  The\n  "),
      _c("em", [_vm._v("Company")]),
      _vm._v("\n  guarantees that the\n  "),
      _c("em", [_vm._v("Company")]),
      _vm._v("\n  has all legal rights needed to license the\n  "),
      _c("em", [_vm._v("Pro Icons")]),
      _vm._v("\n  and\n  "),
      _c("em", [_vm._v("Pro Software")]),
      _vm._v("\n  under this agreement.\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }